import { cva, type VariantProps } from 'class-variance-authority';
import clsx from 'clsx';
// import { type motion } from 'motion/react';
import React from 'react';
import { forwardRefWithAs, type ComponentPropsWithAs } from './polymorphism';

// Your existing typographyCva and variants definition
const typographyCva = cva('font-public-sans m-0 leading-normal', {
  variants: {
    variant: {
      h1: 'text-h1 font-medium',
      h2: 'text-h2 font-medium',
      h3: 'text-h3 font-medium',
      h4: 'text-h4 font-medium',
      h5: 'text-h5 font-medium',
      h6: 'text-h6 font-medium',
      base: 'text-base font-normal',
      sm: 'text-sm font-normal',
    },
    color: {
      inherit: 'text-inherit',
      black: 'text-gray-900',
      gray: 'text-gray-600',
      lightGray: 'text-gray-300',
      green: 'text-green-700',
      red: 'text-red-500',
      white: 'text-white',
      purple: 'text-purple-700',
    },
  },
  defaultVariants: {
    variant: 'base',
    color: 'black',
  },
});

export type TypographyVariant = NonNullable<VariantProps<typeof typographyCva>['variant']>;

// Define types for HTML elements and motion components
// type HTMLHeadingElement = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
// type HTMLParagraphElement = 'p' | 'span' | 'label';
// type MotionElements = typeof motion.p | typeof motion.span;
// type AllowedHTMLVariants = HTMLHeadingElement | HTMLParagraphElement;

// Adjusted TypographyProps to handle both regular and motion components
export type TypographyProps = ComponentPropsWithAs<'p'> & VariantProps<typeof typographyCva>;

export const Typography = forwardRefWithAs<TypographyProps, 'p'>(
  ({ children, variant, color, className, as: Component = 'p', ...rest }, ref) => {
    return (
      <Component ref={ref} {...rest} className={clsx(typographyCva({ variant, color }), className)}>
        {children}
      </Component>
    );
  }
);

Typography.displayName = 'Typography';
